import StateCodeList from "@/utils/state-code-list"

export default {
    
    isStateListPresent : (countryCode) => {
        return StateCodeList[countryCode] != undefined
    },

    getStateFromStateCode(stateCode, countryCode) {
        let stateCodes = StateCodeList[countryCode]
        for (let key in stateCodes) {
            if (stateCodes.hasOwnProperty(key) && stateCodes[key] === stateCode) {
                return key;
            }
        }
        return '';
    }
}